export default "__VITE_ASSET__BHU9zmBu__"